import {FlatList, ListRenderItemInfo} from "react-native";
import React, {useContext} from "react";
import {ServiceContext} from "../../contexts/ServicesContext";
import Service from "../../rest/jtmc/models/Service";

export default function ServicesList(props: { renderItem: (item: ListRenderItemInfo<Service>) => any }) {

    const servicesContext = useContext(ServiceContext);

    return <FlatList data={servicesContext.services ?? [] as Service[]}
                     renderItem={(rItem) => {
                         return props.renderItem(rItem);
                     }}/>
}